module.exports = __webpack_public_path__ + "img/2.ff443162.png";